import * as React from "react"
import {Skeleton} from "@mui/material";

import {useUserApp} from "@hooks";
import { TitleWithPopover, AppTableSeeker } from "@components";
import {isLoadingCommonFilters} from "@signals";
import {topSellersCurrentData} from "../@signals";
import {sellerColumn, discountColumn, dispersionColumn, productsColumn} from "./columns";
import MarketplacesTopSellersToggleButton from "./Actions";


const HEIGHT = 500

export default function MarketplacesTopSellers() {
	const { userUseRRSP } = useUserApp()
	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!topSellersCurrentData.value.length) return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title="Top 20 Sellers" />}
		data={topSellersCurrentData.value}
		columns={[
			sellerColumn(),
			productsColumn(),
			discountColumn(),
			...userUseRRSP ? [dispersionColumn()] : []
		]}
		options={{
			tableBodyHeight: `${HEIGHT}px`,
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			rowsPerPageOptions: [10, 20],
			customToolbar: () => <MarketplacesTopSellersToggleButton userUseRRSP={userUseRRSP}  />
		}}
	/>

}